import React, { FC, useEffect } from 'react';
import OperatorPanelSettingsWrapper from './OperatorPanelSettingsWrapper';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import { fontOP } from '@styles/fonts';
import { env, scaleOP } from '@components/frame';
import { SmallLoading } from '@components/loading';
import QRCode from 'react-native-qrcode-svg';
import { getWebUrl } from '@helpers';
import { connect } from 'react-redux';
import { getAuthInfo } from '@reducers/device';

interface OperatorPanelSettingsAddDeviceProps {
  C: ColorFunction;
  device: any;
  appHubID: number | string;
  getAuthInfo: () => Promise<void>;
}

const OperatorPanelSettingsAddDevice: FC<OperatorPanelSettingsAddDeviceProps> = ({ C, device, appHubID, getAuthInfo }) => {
  useEffect(() => {
    (async () => {
      if (appHubID) {
        await getAuthInfo();
      }
    })();
  }, [appHubID]);

  return (
    <OperatorPanelSettingsWrapper.Root C={C} scale={scaleOP} font={fontOP}>
      <OperatorPanelSettingsWrapper.Header>
        <OperatorPanelSettingsWrapper.HeaderLeftSide>
          <OperatorPanelSettingsWrapper.BackButton />
        </OperatorPanelSettingsWrapper.HeaderLeftSide>
      </OperatorPanelSettingsWrapper.Header>

      <OperatorPanelSettingsWrapper.Content>
        <View style={{ gap: scaleOP(23), alignItems: 'center', width: scaleOP(324) }}>
          <Text style={[fontOP['Title 2'], { color: C('Label/Light/Primary'), textAlign: 'center' }]}>
            {i18n.t('Scan QR code')}
            {'\n'}
            {i18n.t('with your phone')}
          </Text>
          {device.authInfo && device.authInfo.deviceCode ? (
            <QRCode
              value={`${getWebUrl(env)}/qr?addDevice=${JSON.stringify(device.authInfo)}`}
              size={scaleOP(240)}
              backgroundColor={'white'}
              color={'black'}
            />
          ) : (
            <View style={{ width: scaleOP(240), height: scaleOP(240), justifyContent: 'center', alignItems: 'center' }}>
              <SmallLoading />
            </View>
          )}
          <Text style={[fontOP['Body'], { color: C('Label/Light/Secondary'), textAlign: 'center' }]}>
            {i18n.t('Scan this QR code on the Smart Factory app on the phone that you would like to add')}
          </Text>
        </View>
      </OperatorPanelSettingsWrapper.Content>
    </OperatorPanelSettingsWrapper.Root>
  );
};

export default connect(({ device, signalR: { appHubID } }) => ({ device, appHubID }), { getAuthInfo })(ColorWrapper(OperatorPanelSettingsAddDevice));
